import { Component as PComponent } from '~preact';
import { ThemeComponentsContext } from "../ThemeComponentsProvider";

/**
 * A public higher-order component to access the imperative API
 */
export const withThemeComponentsContext = Component => {
	class HOC extends PComponent {
		render(props) {
			return (
				<ThemeComponentsContext.Consumer>
					{(themeComponentsContext) => (
						<Component
							themeComponentsContext={themeComponentsContext}
							{...props}
						/>
					)}
				</ThemeComponentsContext.Consumer>
			);
		}

		static get displayName() {
			return "withThemeComponentsContext(" + (Component.displayName || Component.name) + ")"
		}

		static get wrappedComponent() {
			return Component;
		}
	}

	return HOC;
};

export default withThemeComponentsContext;
